<template>
  <div class="relative inline-block group ml-1">
    <p class="text-argus-emerald-500 cursor-pointer hover:underline" @click="copy">
      {{ label }}
    </p>
    <div v-if="showTooltip" class="absolute left-1/2 -translate-x-1/2 top-full pb-1 z-50">
      <div class="w-2 h-2 bg-argus-forest-800 rotate-45 mx-auto -mb-1"></div>
      <div
        class="bg-argus-forest-800 text-white text-xs px-2 py-1 rounded shadow-lg whitespace-nowrap"
      >
        Copied!
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showTooltip: false,
    }
  },
  methods: {
    async copy() {
      await navigator.clipboard.writeText(this.label)
      this.showTooltip = true
      setTimeout(() => {
        this.showTooltip = false
      }, 3000)
    },
  },
}
</script>
